<template>
  <div id="email-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
      <vs-sidebar class="items-no-padding" parent="#email-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isEmailSidebarActive">
          <alarm-sidebar :alarmTags="alarmTags" @closeSidebar="toggleEmailSidebar" :alarmFilter="alarmFilter" />
      </vs-sidebar>
      <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">
          <!-- SEARCH BAR -->
        <div class="flex border d-theme-dark-bg items-center">
        <!-- <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" v-if="activeUserLevel >= 3" @click.stop="test(true)"/> -->
          <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleEmailSidebar(true)"/>
          <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" placeholder="검색"  v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
        </div>
        <!-- EMAIL ACTION BAR -->
      <div class="email__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light">
        <div class="flex items-center">
          <!-- <vs-checkbox v-model="selectAllCheckBox" icon-pack="feather" :icon="selectAllIcon" class="select-all-chexkbox ml-0">Select All</vs-checkbox> -->
        </div>
        <div class="flex" :click-not-close="clickNotClose" :hidden-background="clickNotClose">
          <feather-icon v-if="activeUserLevel >= 3 && activeSpaceInfo.service == true" icon="EditIcon" class="ml-5 cursor-pointer" svg-classes="h-6 w-6"  @click="activePrompt = true" />
        </div>
      </div>
      <!-- EMAILS LIST -->
      <component :is="scrollbarTag" class="email-content-scroll-area" :settings="settings" ref="alarmListPS" :key="$vs.rtl">
        <transition-group name="list-enter-up" class="email__mails mail__mail-item sm:px-4 px-2 py-6" tag="ul" appear>
          <li class="cursor-pointer email__mail-item" v-for="(alarm) in alarms" :key="alarm.id" @click="updateOpenAlarm(alarm.id)" >
            <alarm-item :alarm="alarm"/>
          </li>
        </transition-group>
      </component>
    </div>
    <alarm-view
      :openAlarmId    = "openAlarmId"
      :isSidebarActive = "isSidebarActive"
      @markUnread      = "activePrompt = true"
      @removeMail      = "removeOpenAlarm"
      @previousMail    = "previousAlarm"
      @nextMail        = "nextAlarm"
      @moveTo          = "moveCurrentTo"
      @closeSidebar    = "closeAlarmViewSidebar"/>
  </div>
</template>

<script>
// import alarmSidebar from "@/views/apps/space/dashboard/alarm/alarmSidebar.vue"
import AlarmSidebar from './AlarmSidebar.vue'
import AlarmItem from "@/views/apps/mypage/alarm/AlarmItem.vue"
import AlarmView from "@/views/apps/mypage/alarm/AlarmView.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: ['alarmId'],
  components: {
    AlarmSidebar,
    'alarm-item':AlarmItem,
    AlarmView,
    VuePerfectScrollbar
  },
  data() {
    return {
      alarmTags: this.$store.state.alarm.alarmTag,
      isEmailSidebarActive : true,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30,
      },
      activePrompt         : false,
      selectedalarm        : [],
      openAlarmId          : null,
      clickNotClose        : true,
      alarms               : [],
      isSidebarActive      : false,
      fileList             : [],

      fileName:'',
    }
  },
  computed: {
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    currentAlarm() {
      return this.$store.getters['alarm/getAlarm'](this.openAlarmId)
    },
    alarmList() {
      return this.$store.state.alarm.alarms
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    unreadAlarmList(){
      return this.$store.state.alarm.newAlarms
    },
    alarmFilter() {
      return this.$route.params.filter
    },
    searchQuery: {
      get() {
        return this.$store.state.alarm.alarmSearchQuery
      },
      set(val) {
        this.$store.commit('alarm/SET_ALARM_SEARCH_QUERY', val)
        this.alarms = this.$store.getters['alarm/filteredAlarm']
      }
    },
  },
  watch: {
    isSidebarActive(value) {
      if (!value) this.showThread = false
    },
    windowWidth() {
      this.setSidebarWidth()
    },
    '$route'() {
      this.openAlarmId = Number(this.$route.params.id)
      this.isSidebarActive = true
    },
    unreadAlarmList(){
      if(this.$route.params.filter.includes('new')){
        this.alarms = this.$store.getters['alarm/filteredAlarm']
      }
    },
    alarmFilter(){
      const scroll_el = this.$refs.alarmListPS.$el || this.$refs.alarmListPS
      scroll_el.scrollTop = 0
      this.$store.commit("alarm/UPDATE_ALARM_FILTER", this.$route.params.filter)
      this.alarms = this.$store.getters['alarm/filteredAlarm']
      this.toggleEmailSidebar()
    },
    searchQuery(){
      this.$store.commit('alarm/SET_ALARM_SEARCH_QUERY', this.searchQuery)
      this.alarms = this.$store.getters['alarm/filteredAlarm']
    }
  },
  methods: {
    acceptAlert() {
      this.$router.push('/apps/space')
    },
    clearFields() {
      this.$nextTick(() => {
        this.title = ''
        this.message = ''
        this.fileList = []
      })
    },
    removeOpenAlarm() {
      this.selectedalarm = [this.openAlarmId]
      this.isSidebarActive = false
    },
    nextAlarm() {
      const currentAlarmIndex = this.alarmList.findIndex((alarm) => alarm.id == this.openAlarmId)
      if (this.alarmList[currentAlarmIndex + 1]){
        this.openAlarmId = this.alarmList[currentAlarmIndex + 1].id
      }
    },
    previousAlarm() {
      const currentAlarmIndex = this.alarmList.findIndex((alarm) => alarm.id == this.openAlarmId)
      if (this.alarmList[currentAlarmIndex - 1]){
        this.openAlarmId = this.alarmList[currentAlarmIndex - 1].id
      }
    },
    closeAlarmViewSidebar() {
      this.isSidebarActive = false
      this.alarms = this.$store.getters['alarm/filteredAlarm']
    },
    moveCurrentTo(to) {
      this.selectedalarm = [this.openAlarmId]
      this.moveTo(to)
    },
    updateOpenAlarm(alarmId) {
      this.openAlarmId = alarmId
      this.isSidebarActive = true
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isEmailSidebarActive = this.clickNotClose = false
      } else {
        this.isEmailSidebarActive = this.clickNotClose = true
      }
    },
    toggleEmailSidebar(value = false) {
      if (!value) {
        this.closeAlarmViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isEmailSidebarActive = value
    },
  },
  created() {
    this.setSidebarWidth()
    this.$store.commit("alarm/UPDATE_ALARM_FILTER", this.$route.params.filter)
    if(this.$route.params.id != 0){
      this.openAlarmId = Number(this.$route.params.id)
      this.isSidebarActive = true
      this.$store.dispatch('alarm/updateAlarm', {'id':this.openAlarmId}).then(()=>{
        this.$store.dispatch('alarm/getAlarm').then(()=>{
          this.$store.commit("alarm/UPDATE_ALARM_FILTER", this.$route.params.filter)
          this.alarms = this.$store.getters['alarm/filteredAlarm']
          })
      })
    }else {
      this.$store.dispatch('alarm/getAlarm').then(()=>{
        this.$store.commit("alarm/UPDATE_ALARM_FILTER", this.$route.params.filter)
        this.alarms = this.$store.getters['alarm/filteredAlarm']
        })
    }
  },
}
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
  text-align: center;
  width:100%;
  display: inline-block;
  padding: .5em .75em;
  color: #000000;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #E7E7E7;
  cursor: pointer;
  border:  solid #E7E7E7 2px;
  border-radius: .25em;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.filebox label:hover {
  background-color: #ffffff;
  border:  solid #E7E7E7 2px;
}

.filebox label:active {
  background-color: #ffffff;
  border:   solid #E7E7E7 2px;
}

.filebox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
#email-app{
    .vs-sidebar--background{
        position: absolute;
    }
    .select-all-chexkbox{
        .vs-checkbox{
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 6.3%);

      &:not(.ps) {
        overflow-y: auto;
      }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }


    .email__mails {

        .email__mail-item {
            transition: all .35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;


                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0px 3px 10px 0px #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar{
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header{
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all .35s;
        }

        .mail__attachment {
          .vs-chip--text {
            margin-left: 0;
            margin-right: 0;
          }
        }
    }
}


// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 730px;
        // max-height: 95vh;

        .vs-dialog-text {
            padding: 0;

            .scroll-area {
                max-height: 75vh;

                &:not(.ps) {
                  overflow-y: auto;
                }
            }

            .compose-mail-attachment {
              .con-input-upload {
                margin: 0;
              }
            }
        }
    }

    .con-img-upload {

    .con-input-upload {
      height: 2.5rem;
      width: 100%;
    }

        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }

    .quill-editor {
        margin-bottom: 1.5rem
    }

    .ql-editor {
        height: 150px;
    }
}

</style>
